<template lang="pug">
    el-dialog(title="调整赛制", width="60%",:visible.sync='visible' :append-to-body="true" :modal-append-to-body='false' @close="closeForm()")
        span.dialog-footer(slot="footer")
            el-button(type="primary") 确 定
            el-button(@click="closeForm()") 取 消
</template>
<script>
    export default {
        name: 'AdjustGameSys',
        data () {
            return {
                visible: false
            }
        },
        methods:{
            init () {
                this.visible = true
            },
            closeForm () {
                this.visible = false
            }
        }
    }
</script>